import PubSub from "underpub-js";

var ListingJobsDirectory = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingJobsDirectory',
	};

	$.extend(true, this.options, options);

};

ListingJobsDirectory.prototype.init = function() {

	var self = this;

};

export default ListingJobsDirectory;
